<template>
    <div style="width:1000px;margin:50px auto;">
        <dl v-html="content">
            {{content}}
        </dl>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
                windowHeight: document.documentElement.clientHeight,   //实时屏幕高度
                content:''
            };
        },
        methods: {

 HtmlToText(htmlStr) {

        let theConvertDiv=document.createElement("div")

        theConvertDiv.innerHTML=htmlStr

        return theConvertDiv.textContent || theConvertDiv.innerText || ""

}
        },

        mounted: function () {
let self=this
let params={type:self.$route.query.type}
self.$axios.get(self.baseApiUrl+'platform/terms/user',{params:params}).then(function (res) {
 if(res.data.code==1){
 self.content=res.data.data.content
 }
})


        },
    }

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// xieyi.vue?2d7202cc